<template>
  <div class="about" v-html="html">
    <!--    <div class="c-body">-->
    <!--      <img style="width: 100%;height: 100%;"-->
    <!--           src="http://qiniu.jinlingleyou.club/about.jpg" alt="oaim首页图片">-->
    <!--      <div class="message_one">-->
    <!--        <p class="p_color"-->
    <!--           style="font-size: 15px !important;-->
    <!--            line-height: 12mm !important;"-->
    <!--           data-locale="oaim">-->
    <!--          oaim design成立于2019年<br/>-->
    <!--          是一家以工业设计为核心的商业创新设计机构<br/>-->
    <!--          我们坚持以用户体验为核心，致力于为企业提供行业整体创新解决方案。<br/>-->
    <!--          我们提供的设计服务有三大类：工业设计、品牌咨询及设计、文创产品开发；<br/>-->
    <!--          工业设计，我们在流程上为客户提供从用户研究、外观设计、结构设计、手板验证、模具监理、生产供应链监理的系统性服务；<br/>-->
    <!--          品牌设计，我们为客户提供品牌咨询、品牌定位、logo设计、VI系统设计、环境导视等服务；<br/>-->
    <!--          文创产品开发，我们为客户提供文化系统梳理、文创品牌定位、logo设计、VI系统设计、文创产品线规范、文创衍生品开发、吉祥物开发等服务；-->
    <!--        </p>-->
    <!--      </div>-->
    <!--      <div class="message_two">-->
    <!--        <p class="p_logo" style="font-size: 15px !important; line-height: 12mm !important;">-->
    <!--          合作伙伴-->
    <!--        </p>-->
    <!--        <p class="p_color" style="font-size: 15px !important;-->
    <!--            line-height: 12mm !important;">-->
    <!--          服务企业：美的、猎豹移动、大嘴猴、诚迈科技、南瑞集团、wawo儿童手表、培恩集成灶、南京立奇电子科技、南京牙小白健康科技、深圳小白-->
    <!--          豆健康科技、南京省人民医院、南京伟思医疗、南京阿凡达机器人科技、杭州奥普集团等，携手企业实现产品创新、品牌形象升级、为其提供优质-->
    <!--          服务。-->
    <!--        </p>-->

    <!--        <div class="logos">-->
    <!--          <img src="http://qiniu.shujunjun.club/about01.png" alt="关于">-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="message_three">-->
    <!--        <p class="p_logo" data-locale="awards">-->
    <!--          奖项-->
    <!--        </p>-->
    <!--        <div class="logos log_btn" style="width: 100%;height: auto">-->
    <!--          <p class="p_color"-->
    <!--             style="font-size: 15px !important;-->
    <!--            line-height: 12mm !important;">-->
    <!--            我们截至目前共获得包括德国红点设计奖、德国IF设计奖、台湾金点奖、当代好设计奖、亚洲CES最佳产品奖在内的四大国际奖项，我们会持续输出更多高质量的产品设计服务于我们的合作伙伴。-->
    <!--          </p>-->
    <!--          <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/about02.png" alt="奖项">-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="message_three">
      <!--标题-->
      <!--      <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">-->
      <!--        合作伙伴-->
      <!--      </p>-->
      <div class="logos log_btn" style="width: 100%;height: auto">

        <!--文字-->
        <p class="p_color"
           style="font-size: 15px !important;
            line-height: 8mm !important;">
          oaim design成立于2019年<br/>
          是一家以用户体验为核心的创新设计机构<br/>
          我们致力于为企业提供行业整体创新解决方案，帮助企业提高产品竞争力，提升企业品牌价值。<br/>
        </p>
        <!--图片-->
        <!--        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/about01.png" alt="奖项">-->

      </div>
    </div>


    <div class="message_three">
      <!--标题-->
      <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">
        合作伙伴
      </p>
      <div class="logos log_btn" style="width: 100%;height: auto">
        <!--文字-->
        <p class="p_color"
           style="font-size: 15px !important;
            line-height: 8mm !important;">
          服务企业：美的、猎豹移动、大嘴猴、诚迈科技、南瑞集团、wawo儿童手表、培恩集成灶、南京立奇电子科技、南京牙小白健康科技、深圳小白
          豆健康科技、南京省人民医院、南京伟思医疗、南京阿凡达机器人科技、杭州奥普集团等，携手企业实现产品创新、品牌形象升级、为其提供优质
        </p>
        <!--图片-->
        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/about01.png" alt="奖项">

      </div>
    </div>



    <div class="message_three">
      <!--标题-->
      <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">
        奖项
      </p>
      <div class="logos log_btn" style="width: 100%;height: auto">
        <!--文字-->
        <p class="p_color"
           style="font-size: 15px !important;
            line-height: 8mm !important;">
          我们截至目前共获得包括德国红点设计奖、德国IF设计奖、台湾金点奖、当代好设计奖、亚洲CES最佳产品奖在内的四大国际奖项，我们会持续输出更多高质量的产品设计服务于我们的合作伙伴。
        </p>
        <!--图片-->
        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/about01.png" alt="奖项">

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "About",
  data() {
    return {
      html: ''
    }
  },
  mounted() {
    // 设置语言
    // this.GLOBFUNC.chanLan()
    this.getMessage()
  },
  methods: {
    getMessage() {
      let that = this
      axios.get('/back/messageOne/message').then(res => {
        let data = res.data.data[0].message
        that.html = data
      })
    }
  }
}
</script>

<style>
.c-body > img {
  width: 100%;
  height: 100%;
}

.message_one {
  margin-left: 16.5%;
  margin-right: 16.5%;
  margin-top: 22mm;
}

.message_one > p {
  /*white-space: pre-wrap;*/
  text-align: left;
  line-height: 12mm;
  font-size: 15px;
}

.message_two {
  margin: 0 16.5%;
}

.logos > p:first-of-type {
  margin-top: 11.5mm;
  margin-bottom: 10mm;
  font-size: 15px;
}

.message_two > p:first-of-type {
  /*white-space: pre-wrap;*/
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  margin-top: 22mm;
  margin-bottom: 11.5mm;
  /*background-color: rgb(213,213,213)*/
}

.message_two > p:last-of-type {
  /*border: 1px solid red;*/
  text-align: left;
  /*white-space: pre-wrap;*/
  font-size: 15px;
  line-height: 12mm;
  /*margin-bottom: 35mm;*/
}

.logos > img {
  width: 100%;
  height: auto;
  /*border: 1px solid green;*/
}

.logos > p {
  text-align: left;
}

.message_three {
  margin: 200px auto; /*30mm 16.5% 0 16.5%*/
  line-height: 12mm;
  /*border: 1px solid blue;*/
  max-width: 1052px;
  /*transform: translateY(20mm);*/
}
@media (min-width: 1250px) {
  .message_three {
    margin: 30mm auto !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 1052px;
    /*margin-top: 35mm;*/
  }
}

@media (min-width: 1100px) and (max-width: 1249px) {
  .message_three {
    margin: 30mm auto !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 954px;
    /*margin-top: 35mm;*/
  }
}

@media (min-width: 510px) and (max-width: 1099px) {
  .message_three {
    margin: 30mm 10% 0 10% !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 954px;
    /*margin-top: 35mm;*/
  }
}

.message_three > p {
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  /*background-color: rgb(213,213,213)*/
}

.p_color {
  color: rgb(80, 80, 80);
  text-align: left;
  word-break: break-word;
}

.p_logo {
  color: rgb(16, 16, 16);
}

.log_btn {
  margin-bottom: 140px;
}
</style>



// WEBPACK FOOTER //
// src/views/about/About.vue